<template>
  <div
    id="intro"
    class="intro-alignment"
    v-scroll-reveal
  >
    <v-container class="max-height">
      <v-row class="max-height align-center">
        <v-col
          class="max-height img-container d-none d-lg-block"
          cols="12"
          lg="6"
        >
          <v-row class="justify-center align-center">
            <img
              src="../../assets/main01.jpg"
              id="introImg01"
              alt=""
            >
            <div class="rect"></div>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          lg="6"
          class="d-flex justify-center px-10"
        >
          <v-row>
            <h2 class="intro-title">
              Cégünkről
            </h2>
            <div class="intro-text">
              15 éve dolgozunk az építőiparban, építőipari beruházóként, társas, családi és ikerházakat
              építünk, építettünk. Ebben a cégformában, 2016.óta dolgozunk, hogy vevőinknek még
              nagyobb biztonságot tudjunk adni, az állam által biztosított kedvezmények, támogatások
              maximális kihasználásában.
              <br />
              <br />
              Első perctől nagy figyelmet fordítunk az építési hely, a telek kiválasztására. Csak olyan telken
              és környezetben kezdünk építkezni, ahol mi magunk is szívesen laknánk. Igyekszünk minden
              igényt kielégítő helyet találni, a majdan felépülő ingatlannak. Továbbá szintén nagy figyelmet
              fordítunk a minőségre és az alvállalkozóink munkájának minőségére is. Minden egyes
              munkamenetet személyesen ellenőrzünk, a későbbi esetleges hibák megelőzésére, valamint
              folyamatosan jelen vagyunk az építkezéseken, hogy ne fordulhasson elő szakszerűtlen
              munkavégzés. Nálunk nincsenek rejtett hibák, a lehető legjobb minőséget építjük be
              házainkba és törekszünk a mai kor elvárásainak megfelelő kivitelezésre és a vevők által elvárt
              modern formákra, megoldásokra. Alvállalkozóink hosszú évek óta szakmájukban dolgozó
              szakemberek, melyekkel kapcsolatunk évtizedes múltra tekint vissza.
              <br />
              <br />
              Ennél kevesebbel be sem érnénk…
              Szem előtt tartjuk a „divatot” alkalmazkodunk a mai igényekhez, mind formai, mind
              minőségi értelemben. A minőség az elsődleges szempont minden egyes ingatlan
              felépülésekor. Nem érjük be az olcsó, nem bizonyított építőanyagokkal, berendezésekkel,
              nem spórolunk ki semmit, mert nekünk sem érdekünk, hogy évekig visszajárjunk javítani a
              hibákat. Nagyon fontos számunkra a vevő elégedettsége, mert minden egyes ingatlan a mi
              gyermekünk.
              <br />
              <br />
              Amennyiben még is elkerülte valami a figyelmünket és valamit javítani kellene az ingatlanon,
              akkor sem bújunk el, hiszen elérhetőségeink 25 éve változatlanok.
              <br />
              <br />
              Megtekinthető referenciáinkat, büszkén mutatjuk meg, mert nincs mit szégyelnünk, sőt
              büszkék vagyunk vevőink elégedettségére!
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style>
#intro {
  background-color: #212832;
  background-size: cover;
  min-height: 600px;
  width: 100%;
}

.max-height {
  height: 100%;
}

#introImg01 {
  z-index: 10;
  width: 35vw;
  max-width: 600px;
  -webkit-box-shadow: 10px 10px 30px -12px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 10px 30px -12px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 10px 30px -12px rgba(0, 0, 0, 0.75);
}

.rect {
  content: "";
  z-index: 9;
  position: absolute;
  width: 25vw;
  max-width: 450px;
  height: 25vw;
  max-height: 400px;
  background-color: transparent;
  border: 5px solid grey;
}

.intro-alignment {
  display: flex;
  align-items: center;
}

.img-container {
  position: relative;
}

.intro-title {
  font-weight: normal;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  color: #d3b364;
}

.intro-text {
  text-align: justify;
  font-size: 1.1rem;
  font-weight: 300;
  margin: 0 3rem 2rem 0;
}

@media screen and (min-width: 601px) and (max-width: 1264px) {
  .intro-text {
    margin: 0 0 2rem 0;
  }
  .intro-title {
    margin-top: 2rem;
    text-align: center;
    width: 100%;
  }
}

@media screen and (max-width: 600px) {
  .intro-title {
    margin-top: 2rem;
    text-align: center;
    width: 100%;
  }
  .intro-text {
    margin: 0 0 2rem 0;
  }
}
</style>


<script>
export default {};
</script>
